'use client'
import Xpayz from '@svg/xpayz.svg'
import Burger from '@svg/burger.svg'
import Close from '@svg/close.svg'
import {usePathname, useRouter} from 'next/navigation'
import Button from './common/Button'
import {useState} from 'react'
import Link from 'next/link'

export default function Navigation({fromHome = false}: {fromHome?: boolean}) {
  const router = useRouter()
  const pathname = usePathname()
  const [open, setOpen] = useState(false)

  const urls = [
    {text: 'Products', url: '/products'},
    {text: 'How it Works', url: '/how-it-works'},
    {text: 'Tokens', url: '/tokens'},
    {text: 'Compliance', url: '/compliance'},
    {text: 'Security', url: '/security'},
    {text: 'FAQ', url: '/faq'},
    {text: 'Contact', url: '/contact'},
  ]

  return (
    <nav className={`z-10`}>
      <div className="flex flex-col rounded-3xl bg-background  text-sub-400 p-5 transition-all duration-300">
        {/* Top row */}
        <div className="flex justify-between items-center">
          <Link href="/">
            <Xpayz className="w-18.5 text-on-background" />
          </Link>
          {/* Desktop */}
          <ul className="hidden lg:flex gap-8">
            {urls.map((url, index) => (
              <li
                key={index}
                className={`font-medium cursor-pointer ${pathname === url.url ? 'text-primary-400 underline' : ''}`}>
                <Link href={url.url}>{url.text}</Link>
              </li>
            ))}
          </ul>
          <div className="hidden lg:flex">
            <Link href="https://app.xpayz.us/login" target="_blank" rel="noopener noreferrer">
              <Button variant="plain" className="mr-4">
                Sign In
              </Button>
            </Link>
            <Link href="https://app.xpayz.us/register" target="_blank" rel="noopener noreferrer">
              <Button variant="primary">Sign Up Free</Button>
            </Link>
          </div>
          <button className="lg:hidden flex flex-col gap-1 text-primary-400" onClick={() => setOpen(!open)}>
            {!open ? <Burger className="w-8 h-8" /> : <Close className="w-8 h-8" />}
          </button>
        </div>

        {/* Mobile menu */}
        <div className={`lg:hidden overflow-hidden transition-all duration-300 ${open ? 'max-h-125 mt-6' : 'max-h-0'}`}>
          <ul className="flex flex-col gap-6">
            {urls.map((url, index) => (
              <li key={index} className={`font-medium ${pathname === url.url ? 'text-primary-400 underline' : ''}`}>
                <Link href={url.url} onClick={() => setOpen(false)}>
                  {url.text}
                </Link>
              </li>
            ))}
          </ul>

          <div className="mt-6">
            <Link href="https://app.xpayz.us/login" target="_blank" rel="noopener noreferrer">
              <Button variant="plain" className="w-full cursor-pointer">
                Sign In
              </Button>
            </Link>
            <Link href="https://app.xpayz.us/register" target="_blank" rel="noopener noreferrer">
              <Button variant="primary" className="w-full cursor-pointer">
                Sign Up Free
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  )
}
